var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-link',{staticClass:"ui-social-network-link",attrs:{"href":_vm.href,"text":_vm.text}},[_c('app-icon',{staticClass:"ui-social-network-link_icon",attrs:{"name":_vm.iconName,"text":_vm.text}}),_c('span',{staticClass:"ui-social-network-link_text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }